import { taskService, CorTaskInsert } from '../TaskManagement/taskService';

export type IssueStrategy = 'parallel' | 'sequential';

export interface FieldIssueContext {
  formRecord: any;                  // current form record (with id)
  mergedFields: Record<string, any>;// latest field values
  fieldDef: any;                    // field definition object (expects name, type, defaultValue)
  navigateTo: string;               // route to open when user clicks task
  formNum?: string;                 // optional form number for description
  formDesc?: string;                // optional form description for description
  sequence?: number;                // sequence for sequential mode
  strategy?: IssueStrategy;         // parallel (default) | sequential
}

export interface FieldHandler {
  onIssue?(ctx: FieldIssueContext): Promise<boolean>; // true if a task was created
  onComplete?(currentTaskId: number, actingPersonnelId: string): Promise<void>;
}

export const handlers: Record<string, FieldHandler> = {};

// Helper to register a handler
export const registerFieldHandler = (type: string, handler: FieldHandler) => {
  handlers[type.toLowerCase()] = handler;
};

// Generic dispatchers
export async function issueFieldTask(ctx: FieldIssueContext): Promise<boolean> {
  const type = String(ctx?.fieldDef?.type || '').toLowerCase();
  const h = handlers[type];
  if (h?.onIssue) {
    return await h.onIssue(ctx);
  }
  return false;
}

export async function completeTask(currentTaskId: number, actingPersonnelId: string) {
  // Default implementation delegates to taskService to complete and unblock
  await taskService.completeTaskAndUnblockNext(currentTaskId, actingPersonnelId);
}
